import {
  React,
  Component,
  Redirect,
  withRouter,
  withCookies
} from 'imports/CommonImports';

import {
  Divider,
} from 'material-ui';

import {CompanyManagers} from 'imports/ComponentsImports';

const styles = {
  pageContainer: {
    padding: '0px 25px'
  },
}

class CompanyView extends Component {

  render() {
    if (this.props.cookies.get('user').position !== 'Gerente Innovación') {
       return <Redirect to='/forbidden'/>;
     }
    return (
      <div style={styles.pageContainer}>
        <h1>Configuración de usuarios</h1>
        <p>Agrega a los gerentes de las áreas de tu empresa que participarán de la medición de i3. Ellos serán los encargados de validar y monitorear los proyectos de sus respectivas áreas. Es obligatorio que agregues al gerente de finanzas porque validará económicamente todos los proyectos. </p>
        <Divider />
        <CompanyManagers history={this.props.history} close={this.props.close}/>
      </div>
    );
  }
}

export default withRouter(withCookies(CompanyView));



// WEBPACK FOOTER //
// ./src/views/setup/CompanyView.js